import { SkillTree } from '../types'

const SKILL_TREE: SkillTree = [
  {
    level: 0,
    name: 'First Timer',
    description:
      "You're just starting out. The surfboard feels more like a slippery diving board than a wave-riding vehicle.",
    unlockRequirements: {}
  },
  {
    level: 1,
    name: 'Whitewater Warrior',
    description: "You've mastered the art of catching broken waves and can occasionally stand up in the whitewater.",
    unlockRequirements: {
      fitness: 1,
      popup: 1,
      paddling: 1,
      whitewater_riding: 1
    }
  },
  {
    level: 2,
    name: 'Green Wave Beginner',
    description: "You're starting to venture into unbroken waves, though they still win most of the battles.",
    unlockRequirements: {
      fitness: 2,
      popup: 2,
      paddling: 2,
      whitewater_riding: 2,
      green_wave_riding: 1
    }
  },
  {
    level: 3,
    name: 'Line Rider',
    description: 'You can catch green waves and ride them straight to the beach. Time to learn some turns!',
    unlockRequirements: {
      paddling: 3,
      popup: 3,
      fitness: 3,
      green_wave_riding: 2,
      bottom_turn_front: 2
    }
  },
  {
    level: 4,
    name: 'Turn Initiator',
    description: "You're beginning to understand wave dynamics and can perform basic turns on the face of the wave.",
    unlockRequirements: {
      green_wave_riding: 3,
      wave_reading: 3,
      bottom_turn_back: 2,
      cutback_back: 2,
      cutback_front: 2
    }
  },
  {
    level: 5,
    name: 'Flow Finder',
    description: "You're developing your own style and can link multiple turns together on a good wave.",
    unlockRequirements: {
      fitness: 4,
      speed_generation: 3,
      forecasting_and_observing: 2,
      cutback_front: 3,
      cutback_back: 3,
      top_turn_front: 2
    }
  },
  {
    level: 6,
    name: 'Lineup Regular',
    description:
      "You're a familiar face in the lineup and can read waves well enough to position yourself in the right spot.",
    unlockRequirements: {
      green_wave_riding: 4,
      bottom_turn_front: 3,
      bottom_turn_back: 3,
      forecasting_and_observing: 3,
      wave_reading: 4,
      top_turn_back: 3
    }
  },
  {
    level: 7,
    name: 'Style Master',
    description: "Your surfing has developed a distinctive style, and you're comfortable in most conditions.",
    unlockRequirements: {
      bottom_turn_back: 4,
      speed_control: 2,
      top_turn_front: 3,
      top_turn_back: 3,
      speed_generation: 4,
      floater: 2
    }
  },
  {
    level: 8,
    name: 'Power Surfer',
    description: "You're attacking waves with power and precision, making sections that others struggle with.",
    unlockRequirements: {
      fitness: 5,
      barrel: 3,
      cutback_front: 4,
      top_turn_front: 4,
      top_turn_back: 3,
      speed_control: 4,
      floater: 3,
      speed_generation: 5
    }
  },
  {
    level: 9,
    name: 'Progressive Performer',
    description: "You're pushing your surfing above the lip and starting to land aerial maneuvers.",
    unlockRequirements: {
      aerial: 3,
      speed_control: 5,
      barrel: 4,
      air_reverse: 3,
      floater: 4,
      top_turn_front: 5,
      top_turn_back: 5,
      cutback_front: 5,
      cutback_back: 5
    }
  },
  {
    level: 10,
    name: 'Complete Surfer',
    description: "You've mastered all aspects of surfing and can handle any conditions with confidence and style.",
    unlockRequirements: {
      paddling: 5,
      popup: 5,
      green_wave_riding: 5,
      forecasting_and_observing: 5,
      wave_reading: 5,
      bottom_turn_front: 5,
      bottom_turn_back: 5,
      aerial: 5,
      air_reverse: 5,
      barrel: 5
    }
  },
  {
    level: 11,
    name: 'The G.O.A.T. Surfer',
    description:
      "You've transcended normal human limitations and redefined what's possible in surfing. Your name is whispered with reverence on beaches worldwide, and your sessions become the stuff of legend.",
    unlockRequirements: {
      top_turn_front: 6,
      top_turn_back: 6,
      aerial: 6,
      air_reverse: 6,
      barrel: 6
    }
  }
]

export default SKILL_TREE
